<template>
  <div class="disclaimer">
    <p>{{ $_translations.value.page_store_section_vat_description_1 }}</p>
    <p>{{ $_translations.value.page_store_section_vat_description_2 }}</p>
  </div>
</template>

<script setup>
</script>
